import FormBody from './form-body'
import FormButton from './form-button'
import FormCheckBox from './form-checkbox'
import FormDivisor from './form-divisor'
import FormFooter from './form-footer'
import FormInfo from './form-info'
import FormInput from './form-input'
import FormRadio from './form-radio'
import FormRoot from './form-root'
import FormSectionText from './form-section-text'
import FormSelect from './form-select'
import FormStepper from './form-stepper'

export const Form = {
  Root: FormRoot,
  Info: FormInfo,
  Body: FormBody,
  Input: FormInput,
  Radio: FormRadio,
  Select: FormSelect,
  Button: FormButton,
  Footer: FormFooter,
  Stepper: FormStepper,
  Divisor: FormDivisor,
  CheckBox: FormCheckBox,
  SectionText: FormSectionText,
}
